import React from 'react'
import { App, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { rubricPersistActions } from '../../../../../../../store/slices/rubric.persist.slice'
import { rubricPersistSelectors } from '../../../../../../../store/selectors/rubric.persist.selectors'

const DiscardButton = () => {
    const { modal } = App.useApp()
    const dispatch = useDispatch()
    const { token } = useParams()
    const currentStep = useSelector(rubricPersistSelectors.currentStep(token))

    const handleDiscard = () => {
        modal.confirm({
            title: 'Discard Import',
            content: 'Are you sure you want to discard the import process? All changes will be lost.',
            onOk: () => {
                dispatch(rubricPersistActions.resetAssignment({ token }))
            },
            okText: 'Discard',
            okType: 'danger',
        })
    }

    return currentStep === 0 ? null : (
        <Button danger onClick={handleDiscard}>
            Discard
        </Button>
    )
}

export default DiscardButton
